import React, { useState } from 'react';

export default function Login({ onLogin, onPatientAccess }) {
  const [view, setView] = useState('select'); // 'select' | 'admin-login'
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [mfaCode, setMfaCode] = useState('');
  const [requireMfa, setRequireMfa] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAdminSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim() || (requireMfa && !mfaCode.trim())) {
      setError('Please fill in all required fields.');
      return;
    }
    setError('');
    setLoading(true);

    try {
      const result = await onLogin(username, password, requireMfa ? mfaCode : null);
      setLoading(false);
      
      if (result && result.requireMfa) {
        setRequireMfa(true);
        setError(''); // Clear errors, just need code now
        return;
      }
      
      if (!result) {
        setError('Invalid credentials or MFA code.');
      }
    } catch (err) {
      setLoading(false);
      setError('Connection to backend failed. Please verify server status.');
    }
  };

  return (
    <div className="login-wrapper animate-fade">
      <div className="login-container glass-card">
        {view === 'select' ? (
          <div className="login-selection-view">
            <div className="login-header">
              <div className="brand-logo">🏥</div>
              <h2>Welcome to MedSafety Connect</h2>
              <p>Select your portal to continue securely</p>
            </div>

            <div className="selection-cards">
              {/* Patient Card */}
              <div className="selection-card patient" onClick={onPatientAccess}>
                <div className="selection-card-icon">📋</div>
                <h3>Patient Portal</h3>
                <p>Submit an Adverse Drug Reaction (ADR) self-report. No account or password required.</p>
                <button className="btn btn-primary btn-block">
                  Submit ADR Report →
                </button>
              </div>

              {/* Staff/Admin Card */}
              <div className="selection-card staff" onClick={() => setView('admin-login')}>
                <div className="selection-card-icon">🔐</div>
                <h3>Staff Portal</h3>
                <p>Authorized clinic personnel login to manage patient records and administrative tasks.</p>
                <button className="btn btn-secondary btn-block">
                  Staff Sign In →
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="admin-login-view animate-slide">
            <button className="back-to-select-btn" onClick={() => { setView('select'); setError(''); }}>
              ← Back to Portal Selection
            </button>

            <div className="login-header">
              <div className="brand-logo">🔐</div>
              <h2>Clinic Staff Sign In</h2>
              <p>Enter your credentials to access the administrative portal</p>
            </div>

            <form onSubmit={handleAdminSubmit} className="login-form">
              {error && (
                <div className="login-error-alert animate-fade">
                  <span>⚠️</span> {error}
                </div>
              )}

              {requireMfa ? (
                <div className="form-group animate-fade">
                  <label className="form-label" htmlFor="mfaCode">Authenticator Code (6 digits)</label>
                  <input
                    id="mfaCode"
                    type="text"
                    className="form-control"
                    placeholder="e.g. 123456"
                    value={mfaCode}
                    onChange={(e) => setMfaCode(e.target.value)}
                    disabled={loading}
                    autoComplete="one-time-code"
                  />
                </div>
              ) : (
                <>
                  <div className="form-group">
                    <label className="form-label" htmlFor="username">Username</label>
                    <input
                      id="username"
                      type="text"
                      className="form-control"
                      placeholder="e.g. superadmin"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label" htmlFor="password">Password</label>
                    <input
                      id="password"
                      type="password"
                      className="form-control"
                      placeholder="••••••••"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={loading}
                    />
                  </div>
                </>
              )}

              <button
                type="submit"
                className="btn btn-primary btn-block"
                style={{ marginTop: '10px' }}
                disabled={loading}
              >
                {loading ? 'Verifying...' : 'Sign In'}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
